module.exports = __webpack_public_path__ + "static/media/contact.e18e0cbf.JPG";